module.exports = __webpack_public_path__ + "img/money-pound-box-line.e0ee6841.svg";